import React, { Component } from "react";
import { Link } from "react-router-dom";

import { Row, Col } from "reactstrap";

import contentData from "../utils/contentData";

class Content extends Component {
  render() {
    return (
      <div className="next-steps my-5">
        <h2 className="my-5 text-center">How does it work?</h2>
        
        {/* Single row with all three items */}
        <Row className="d-flex justify-content-center">
          {contentData.map((col, i) => (
            <Col key={i} md={4} lg={3} className="mb-4 text-center">
              <div className="mb-3">
                <span className="badge badge-primary mb-2">{i + 1}</span>
                <h6>
                  <Link to={col.link}>
                    {col.title}
                  </Link>
                </h6>
              </div>
              <p>{col.description}</p>
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}

export default Content;
